import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import PageContainer from '../fragments/page-container'
import {
    action_add_list_collection_list,
    action_fetch_list_collection_list,
    action_fetch_list_collection_sorters,
    action_fetch_list_collection_filter,
} from '../../../../store/actions/pages/list-collections'


import List from '../components/list'
import { filterItemsToString, getFilterItemsFromQuery } from '../utils'
import queryString from 'query-string'
import Empty from '../components/list/empty'
import classes from '../style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import paths from './paths.json'

import { useApp, useQuery } from '../../../hooks/common'

import Swiper from '../../../components/swiper/autowidth'
import { Link, useLocation } from 'react-router-dom'
import { withSwiper } from '../../moduleable/modules/list/components/swiper-tabs'
import BlockImage from '../../../components/image/block-image'
import Affix from '../../../components/affix'
import withSource from '../../../hocs/source-scoll'
import { useSensors } from '../../../hooks/sensor'
import { generateFilter } from '../../../utils/sensor'

const getValidFilterItems = items => {
    const newItems = []

    items?.forEach(item => {
        if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
            newItems.push(item)
        }
    })
    return newItems
}


const parseSearch = search => {
    const parsed = queryString.parse(search)
    if (parsed && parsed.sort_by) {
        parsed.parentSkus = parsed.sort_by
    }
    return parsed
}

const parseParams = search => {
    if (!search) return
    let newParams = {}
    Object.keys(search).forEach(key => {
        if (search[key] instanceof Array) {
            newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
        } else {
            newParams[key] = search[key]
        }
    })

    if (search?.sort_by) {
        newParams['parentSkus'] = search.sort_by
    }
    return newParams
}

const Tab = withSource(props => {
    useStyles(classes)
    const { item, currentCollectionId, innerRef, position, resourcePageTitle, theme } = props
    const location = useLocation()

    return <Link ref={innerRef} to={`${location.pathname}?collectionId=${item.id}`} replace className={classes.Tab} style={{
        color: item.id === currentCollectionId ? theme?.activeFontBgColor : '#fff',
        borderColor: item.id === currentCollectionId ? theme?.activeFontBgColor : 'transparent',
        display: 'inline-block',
        height: '100%'
    }}
        data-position={position}
        data-type='listing-tab'
        data-content={`collection@${item.id}`}
        data-title={resourcePageTitle}
    >
        {
            item?.icon && <img className={classes.Icon} src={item?.icon}/>    
        }
        <span dangerouslySetInnerHTML={{ __html: item.styledTitle || item.title }} />
    </Link>
})

const TabSwiper = withSwiper(props => {

    useStyles(classes)
    const { tabClick, collections, theme, resourcePageTitle } = props

    const query = useQuery()

    const currentCollectionId = query.collectionId || collections?.[0]?.id

    return <Swiper options={{
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        onClick: tabClick,
        spaceBetween: 14,
    }} className={classes.ListCollectionTabs} style={{
        backgroundColor: theme?.containerColor
    }} items={collections} render={(item, index) => {
        return <Tab theme={theme} resourcePageTitle={resourcePageTitle} item={item} key={item.id} position={index+1} currentCollectionId={currentCollectionId}/>
    }} />
})



const ListCollection = props => {

    useStyles(classes)

    const dispatch = useDispatch()
    const pageCollection = useSelector((state) => state.pageListCollections)
    const isApp = useApp()

    const query = useQuery()
    const store = useStore()
    const { params } = props.match
    const location = useLocation()

    const ref = useRef()

    const search = parseSearch(location.search)
    const filterItems = getFilterItemsFromQuery(search)
    const [value, setValue] = useState(filterItems)
    const [sorter, setSorter] = useState(Number(search['sort']) || 0)
    const [tag, setTag] = useState({
        fieldName: 'tags',
        selections: (search?.tags instanceof Array) ? (search.tags.join(',').split(',').map(s => ({ value: s }))) : (search.tags?.split(',').map(s => ({ value: s })))
    })

    useEffect(async () => {
        const { messageConfig } = pageCollection
        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            await ListCollection.fetchData(store, params, { ...search, collectionId: query.collectionId || messageConfig?.collections?.[0]?.id }, {})
            setValue(getFilterItemsFromQuery(search))

            try {
                if (ref.current.getBoundingClientRect().top < 0) {
                    ref.current.scrollIntoView({ block: 'start' })
                }
            } catch (e) { }

        }

    }, [location.search, query.collectionId])


    const initPage = async () => {

    }


    const submitHandle = filterItems => {
        let resultSearch
        if (tag) {
            if (filterItems?.some(f => f.fieldName === 'tags')) {
                resultSearch = filterItemsToString(filterItems)
            } else {
                if (tag.value) {
                    resultSearch = filterItemsToString([...filterItems, { fieldName: 'tags', selections: [tag] }])
                } else {
                    resultSearch = filterItemsToString([...filterItems])
                }
            }
        } else {
            resultSearch = filterItemsToString(filterItems)
        }
        props.history.replace(`${location.pathname}?${resultSearch}`)
    }

    const handleSorter = sorter => {
        setSorter(sorter)
        props.history.replace(`${location.pathname}?${queryString.stringify({ ...search, sort: sorter })}`)
    }

    const handleTag = tag => {
        setTag(tag)
        const tagSearch = { ...search, tags: tag?.value }
        props.history.replace(`${location.pathname}?${queryString.stringify(tagSearch)}`)
    }

    const onScroll = () => {
        const initialFilterItems = getFilterItemsFromQuery(search)
        const { sorters, messageConfig } = pageCollection

        const requestSorter = (sorters instanceof Array) ? sorters?.[sorter]?.value : sorter
        const filter = {
            collectionId: search?.collectionId || messageConfig?.collections?.[0]?.id,
            sorter: requestSorter,
            filterItems: getValidFilterItems(initialFilterItems),
        }

        dispatch(action_add_list_collection_list(filter, { ...search, skip: pageCollection?.skip }, {}))
    }

    const [sensors, setSensors] = useState(useSensors())

    const filterStr = generateFilter(pageCollection?.filterData, pageCollection?.sorters)


    return <div ref={ref}>




        <PageContainer links={[
            {
                href: '#',
                title: paths?.find(c => c.path === location.pathname)?.title,
                keywords: []
            }
        ]}
            extra={
                () => {
                    return <>
                        {
                            pageCollection?.messageConfig?.banner && pageCollection?.messageConfig?.banner.src && <BlockImage
                                sensors={
									{
                                        position: 1,
                                        content: pageCollection?.messageConfig?.banner?.refId,
                                        type: '1',
                                        title: 'list'
                                    }
                                }
                                src={pageCollection?.messageConfig?.banner.src}
                                href={isApp ? pageCollection?.messageConfig?.banner?.appHref : pageCollection?.messageConfig?.banner?.href} width={pageCollection?.messageConfig?.banner?.width} height={pageCollection?.messageConfig?.banner?.height} />
                        }

                        <Affix offsetTop={isApp ? 0 : 44}>
                            <TabSwiper resourcePageTitle={pageCollection?.messageConfig?.refId} theme={pageCollection?.messageConfig?.theme} collections={pageCollection?.messageConfig?.collections} />
                        </Affix>
                    </>
                }
            }
            filterVo={pageCollection?.filterVo}
            sorters={pageCollection?.sorters}
            onSubmit={submitHandle}
            value={value}
            sorter={sorter}
            onSorter={handleSorter}
            onTag={handleTag}
            tag={tag}
            searchOffSet={40}
        >
            {
                pageCollection?.finished && (!pageCollection?.list || pageCollection?.list?.length < 1) ? <Empty /> : <List filter={filterStr} sensors={sensors} column={`collection@${query.collectionId || pageCollection?.messageConfig?.collections?.[0]?.id}`} products={pageCollection.list} request={onScroll} loading={pageCollection?.loading} finished={pageCollection?.finished} />
            }
        </PageContainer>
    </div>
}


ListCollection.fetchData = async (store, params, search, headers) => {

    const initialFilterItems = getFilterItemsFromQuery(search)
    const sort = search.sort || 0
    const sorters = await store.dispatch(action_fetch_list_collection_sorters({}, headers))
    const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
    const collectionId = search?.collectionId

    const filter = {
        collectionId,
        sorter: sorter,
        filterItems: getValidFilterItems(initialFilterItems),
    }

    const values = await Promise.all([
        store.dispatch(action_fetch_list_collection_list(filter, parseParams(search), headers)),
        store.dispatch(action_fetch_list_collection_filter({ collectionId }, headers)),
    ])
    return [...values, sorters]
}

export default ListCollection
